import setActivePage from './set-active-page';

export default {
  setActivePage,
};
